import { LocalizationProvider } from '@mui/lab';
import DateAdapter from '@mui/lab/AdapterMoment';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';
import { AppContent } from './AppContent';
import { AuthProvider } from './contexts/authWindows';
import { TranslationProvider } from './contexts/translation';
import { darkTheme, defaultTheme, ThemeType, useLocalTheme } from './hooks/useLocalTheme';

const queryClient = new QueryClient();

function App() {
  // const { user } = useAuth();
  // if (!user) return <Loader />;
  return <AppContent />;
}

export default function AppContainer() {
  const { localTheme } = useLocalTheme();

  return (
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <BrowserRouter>
          <AuthProvider>
            <TranslationProvider>
              <LocalizationProvider dateAdapter={DateAdapter}>
                <ThemeProvider theme={localTheme === ThemeType.DARK ? darkTheme : defaultTheme}>
                  <App />
                  <ReactQueryDevtools />
                </ThemeProvider>
              </LocalizationProvider>
            </TranslationProvider>
          </AuthProvider>
        </BrowserRouter>
      </SnackbarProvider>
    </QueryClientProvider>
  );
}
